<template>
  <div>
    <v-tooltip bottom color="primary">
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          class="primary text--white ma-0 px-2 py-0"
          :disabled="
            !hasUserFilteredInputVariables ||
              outputVariables.length == 0 ||
              filteredData.length == 0
          "
          v-on="{ ...tooltip }"
          @click="dialog = !dialog"
        >
          Save Study Group
        </v-btn>
      </template>
      <span>Save the current study group, adding it to the list above.</span>
    </v-tooltip>

    <!-- SAVE COLLECTION FORM DIALOG -->
    <v-dialog v-model="dialog" width="500">
      <v-card class="rounded-lg">
        <v-card-title color="white" primary-title>
          <v-icon color="primary">save</v-icon>
          <span class="primary--text text--darken-3 title pl-2"
            >Save Study Group</span
          >
        </v-card-title>

        <v-card-text class="primary primary--text text--lighten-5 pt-4">
          <div
            v-if="hasUserFilteredOutputVariables"
            class="black--text title pa-4 yellow lighten-4 font-weight-regular"
          >
            <v-icon class="pa-1" color="warning" medium>warning</v-icon>
            WARNING:<br clear="both" />Outcome variable filters will not be
            saved with the study group unless they are moved to the PREDICTOR
            VARIABLES section.<br clear="both" />
          </div>

          <v-form
            ref="form"
            v-model="valid"
            class="white"
            @submit.prevent="onSaveCohort"
          >
            <v-text-field
              ref="vtf"
              v-model="cohortName"
              :rules="[
                () => !!cohortName || 'Study group name is required.',
                () =>
                  !cohortNames.includes(cohortName) ||
                  'A study group with that name already exists.',
                () =>
                  !cohortName.startsWith('[O]_') ||
                  'Study group name cannot start with `[O]_`.',
              ]"
              prepend-inner-icon="table_chart"
              label="Please name your study group."
              filled
              text
              background-color="grey lighten-4"
              class="mt-2"
            >
            </v-text-field>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialog = false">
            <v-icon left>close</v-icon> Cancel
          </v-btn>
          <v-btn :loading="loading" color="primary" @click="onSaveCohort">
            <v-icon left>save</v-icon> Save Study Group</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { actions, getters, state } from '@/store/modules/cohortManager/types';

// which store?
export default {
  props: {
    variables: {
      type: Array,
      default: () => [],
    },
    datasetIds: {
      type: Array,
      default: () => [],
    },
    cohorts: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    cohortName: '',
    valid: true,
    dialog: false,
    loading: false,
  }),
  computed: {
    ...mapState('cohortManager', {
      cohort: state.COHORT,
      filteredData: state.FILTERED_DATA,
      inputVariables: state.INPUT_VARIABLES,
      outputVariables: state.OUTPUT_VARIABLES,
      selectedAnalysisMode: state.SELECTED_ANALYSIS_MODE,
    }),
    ...mapGetters('cohortManager', {
      hasUserFilteredInputVariables: getters.HAS_USER_FILTERED_INPUT_VARIABLES,
      hasUserFilteredOutputVariables:
        getters.HAS_USER_FILTERED_OUTPUT_VARIABLES,
    }),
    cohortNames() {
      return this.cohorts.map(c => c.label.replace(/^\[O\]_/, ''));
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.showing();
      }
    },
    cohort(newCohort) {
      if (
        newCohort.id != -1 &&
        newCohort.label != 'Choose Study Group' &&
        newCohort.label != 'New Study Group'
      ) {
        this.cohortName = newCohort.label.replace(/^\[O\]_/, '');
      }
    },
  },
  methods: {
    ...mapActions('cohortManager', {
      saveSelectedCohort: actions.SAVE_SELECTED_COHORT,
    }),
    showing() {
      setTimeout(() => {
        this.$refs.vtf.focus();
      });
    },
    async onSaveCohort() {
      let { cohortName } = this;

      if (this.selectedAnalysisMode == 'Outcome based') {
        cohortName = '[O]_' + cohortName;
      }

      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          await this.saveSelectedCohort({ cohortName });
          this.loading = false;
          this.dialog = false;
          this.$emit('cohortSaved', true);
        } catch (err) {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
